import {Pipe, PipeTransform} from '@angular/core';
import {IGridColumn} from 'src/app/custom-grid/models/grid-column.interface';

@Pipe({
  name: 'gridColumnCell',
  pure: true
})
export class GridColumnCellPipe<T> implements PipeTransform {
  transform(item: T, column: IGridColumn<T>): string | T[keyof T] | null {
    return column?.getHtmlTemplate?.(item) || item?.[column?.field] || '';
  }
}
